import { pushgroundApi } from '../../app/services/pushgroundApi';
import type { User } from './loginSlice';

export const loginApi = pushgroundApi.injectEndpoints({
  endpoints: (builder) => ({
    logInUser: builder.query({
      query: (base64Credentials) => ({
        url: 'v2/login',
        headers: { Authorization: `Basic ${base64Credentials}` },
      }),
    }),
    getUserData: builder.query<User, void>({
      query: () => 'v2/me',
    }),
  }),
});

export const { useLazyLogInUserQuery, useLazyGetUserDataQuery } = loginApi;
